/* eslint-disable @typescript-eslint/no-empty-function */
import React, {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  Center,
} from '@chakra-ui/react';
import {Container} from './components/container';

export type ModalTypes = 'redeem' | 'share' | 'certificate' | 'wallet' | 'deed';

interface IModal {
  type: ModalTypes;
  isOpen: boolean;
  onClose: () => void;
  signature?: string;
  onChange?: (mt: ModalTypes) => void;
  userId?: string;
  assetId?: string;
  transactionId?: string;
  redeemCode?: string;
  isDeed?: boolean;
  disableDeedDownload?: boolean;
}

const ModalContext = createContext<
  IModal & {setIsLoaded: Dispatch<SetStateAction<boolean>>; isLoaded: boolean}
>({
  type: 'share',
  isOpen: false,
  onClose: () => {},
  onChange: () => {},
  setIsLoaded: () => {},
  isLoaded: false,
  isDeed: false,
  disableDeedDownload: false,
});

export const useModalContext = (): IModal & {
  setIsLoaded: Dispatch<SetStateAction<boolean>>;
  isLoaded: boolean;
} => useContext(ModalContext);

export const Modal: FC<IModal> = ({
  type,
  isOpen,
  onClose,
  signature,
  onChange,
  userId,
  assetId,
  transactionId,
  redeemCode,
  isDeed,
  disableDeedDownload,
}) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay bgColor="rgba(0,0,0,0.8)" />
      <ModalContent bgColor="transparent" alignItems="center" height="100%">
        <Center width="100%" height="100%" flexDir="column" px={4}>
          <ModalContext.Provider
            value={{
              type,
              isOpen,
              onClose,
              isLoaded,
              setIsLoaded,
              signature,
              onChange,
              userId,
              assetId,
              transactionId,
              redeemCode,
              isDeed,
              disableDeedDownload,
            }}
          >
            <Container type={type} />
          </ModalContext.Provider>
        </Center>
        <ModalBody />
      </ModalContent>
    </ChakraModal>
  );
};
